import AdminDashboardPage from './AdminDashboardPage';
import SalesDashboardPage from './SalesDashboardPage';
import StudentDashboardPage from './StudentDashboardPage';
import SupportDashboardPage from './SupportDashboardPage';
import TeacherDashboardPage from './TeacherDashboardPage';
import { useAuth } from '../context/AuthContext';

/**
 * Module 12 gives every role its own landing dashboard, so this is now only the switch
 * between them.
 *
 * <p>It holds no state and calls no hooks on purpose: each dashboard fetches its own
 * data, and a shared parent that fetched something for all of them would be doing work
 * four of the five roles do not use.
 */
const DASHBOARDS = {
  SUPER_ADMIN: AdminDashboardPage,
  SUPPORT_EXECUTIVE: SupportDashboardPage,
  SALES_REP: SalesDashboardPage,
  TEACHER: TeacherDashboardPage,
  STUDENT: StudentDashboardPage,
};

export default function DashboardPage() {
  const { user } = useAuth();
  const Dashboard = DASHBOARDS[user?.role];

  if (!Dashboard) {
    // Unreachable for the five roles that exist; a blank screen would be worse than
    // saying so if a sixth is ever added without a dashboard.
    return (
      <div className="page-head">
        <h1>Dashboard</h1>
        <p>There is no dashboard for this role yet.</p>
      </div>
    );
  }
  return <Dashboard />;
}
